export const VOUCHER_TYPES = {
  1: 'شارژ اعتبار',
  2: 'تخفیف مبلغی',
  4: 'تخفیف درصدی - یکبار مصرف برای یک آیتم',
  8: 'تخفیف درصدی - بدون محدودیت',
  16: 'تخفیف درصدی - یکبار مصرف برای یک فاکتور',
};

export const PERCENTAGE_VOUCHER_INDEXES = [4, 8, 16];
